import axios from "infra/http";
import { useMutation } from "react-query";
import { TipoAutorizacaoPortariaParametroItem } from "../typings";

function useSalvarParametrosPortaria() {
  return useMutation(
    (form: { items: TipoAutorizacaoPortariaParametroItem[] }) => {
      return axios.put(`/v1/portaria/tipo-autorizacao-parametros`, form);
    }
  );
}

export default useSalvarParametrosPortaria;
